import { createModel } from "@rematch/core";
import { MarketShareFilterState, MarketShareState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: MarketShareState = {
  loading: true,
  postcodes: {
    features: [],
    type: "FeatureCollection",
  },
  postcodesIA: [],
  pending: null,
};

export const marketShare = createModel<RootModel>()({
  state: initialState as MarketShareState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(state, payload: Partial<MarketShareState>, requestId: string) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchMarketShare(
      marketShareFilter: MarketShareFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.marketShare.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.marketShare.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const marketShareResult = await api.fetchMarketShare(
          token,
          marketShareFilter
        );
        dispatch.marketShare.fetchSuccess(marketShareResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.marketShare.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/marketShare.ts